// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../assets/images/search_icon24.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
This computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), 
is the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.
*/
.ui.grid {
  margin: -1rem auto -1rem auto;
}

.ui.grid {
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  flex-direction: row;
  flex-wrap: wrap;
  -webkit-box-align: stretch;
  align-items: stretch;
  padding: 0;
}

.ui.column.grid > [class*='eight wide'].column,
.ui.grid > .column.row > [class*='eight wide'].column,
.ui.grid > .row > [class*='eight wide'].column,
.ui.grid > [class*='eight wide'].column {
  width: 50% !important;
}

.ui.grid > .column:not(.row) {
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.ui.grid > .column:not(.row),
.ui.grid > .row > .column {
  position: relative;
  display: inline-block;
  width: 6.25%;
  padding-right: 0rem;
  vertical-align: top;
}

.ui.search {
  height: inherit;
}

.ui.input {
  position: relative;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  height: 1.88rem;
  border-radius: 14px;
}

.ui.input > input {
  margin: 0;
  max-width: 100%;
  -webkit-box-flex: 1;
  flex: 1 0 auto;
  outline: 0;
  text-align: left;
  line-height: 1.313rem;
  font-size: var(--default-FontSize);
  font-family: var(--default-FontName);
  font-weight: var(--default-FontWeight);
  color: var(--default-FontColour);
  padding: 0.67857143em 1em;
  /* background-color: #ececec; */
  /* border: 0.006rem solid var(--controlborder-colour); */
  background-color: var(--inputbackgroundColor);
  border: 1px solid var(--searchBarControlBorder-colour);
  box-shadow: none;
  border-radius: 50px;
  font-style: normal;
  padding-left: 20px;
  padding-right: 74px;
}

button,
input {
  overflow: visible;
}

*,
:after,
:before {
  box-sizing: inherit;
}

.ui.icon.input > i.icon:not(.link) {
  pointer-events: none;
}

.ui.search .prompt ~ .search.icon {
  cursor: pointer;
  background-color: #1f3c88;
  content-visibility: hidden;
}

.ui.icon.input > i.icon {
  position: absolute;
  line-height: 1;
  text-align: center;
  top: 0;
  right: 0;
  margin: 0;
  height: 100%;
  width: 6.325%;
  transition: opacity 0.3s ease;
  border-top-right-radius: 50px;
  border-bottom-right-radius: 50px;
}

i.icon,
i.icons {
  font-size: 0.833vw;
}

i.icon {
  display: inline-block;
  font-family: Icons;
  font-style: normal;
  font-weight: 400;
  text-decoration: inherit;
  speak: none;
  -webkit-font-smoothing: antialiased;
  backface-visibility: hidden;
}

*,
:after,
:before {
  box-sizing: inherit;
}

.ui.category.search .results {
  width: 28em;
}

.ui.search > .results {
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  transform-origin: center top;
  white-space: normal;
  text-align: left;
  text-transform: none;
  background: #fff;
  margin-top: 0.5em;
  border-radius: 0.28571429rem;
  box-shadow: 0 2px 4px 0 rgb(34 36 38 / 12%), 0 2px 10px 0 rgb(34 36 38 / 15%);
  border: 1px solid #d4d4d5;
  z-index: 998;
}

.transition {
  animation-iteration-count: 1;
  animation-duration: 0.3s;
  animation-timing-function: ease;
  animation-fill-mode: both;
}

*,
:after,
:before {
  -webkit-box-sizing: inherit;
  box-sizing: inherit;
}

.ui.search > .results > .message {
  padding: 1em 1em;
}

.ui.search > .results > :last-child {
  border-radius: 0 0 0.28571429rem 0.28571429rem;
}

*,
:after,
:before {
  box-sizing: inherit;
}

.ui.search > .results > .message .header {
  font-size: var(--label-FontSize);
  font-family: var(--label-FontName);
  font-weight: var(--label-FontWeight);
  color: var(--label-FontColour);
}

/*Popup*/
.ui.category.search .results.animating,
.ui.category.search .results.visible {
  display: none !important;
}

.ui.category.search .results {
  width: 28em;
}

.ui.search > .results {
  position: absolute;
  top: 100%;
  left: 0;
  transform-origin: center top;
  white-space: normal;
  text-align: left;
  text-transform: none;
  background: #fff;
  margin-top: 0.5em;
  border-radius: 0.28571429rem;
  box-shadow: 0 2px 4px 0 rgb(34 36 38 / 12%), 0 2px 10px 0 rgb(34 36 38 / 15%);
  border: 1px solid #d4d4d5;
  z-index: 998;
}

.visible.transition {
  display: block !important;
  visibility: visible !important;
  max-height: 70vh;
  overflow: scroll;
}

.transition {
  animation-iteration-count: 1;
  animation-duration: 0.3s;
  animation-timing-function: ease;
  animation-fill-mode: both;
}

.ui.category.search > .results .category {
  display: table-row;
  background: #f3f4f5;
  box-shadow: none;
  transition: background 0.1s ease, border-color 0.1s ease;
}

.ui.search > .results > :first-child {
  border-radius: 0.28571429rem 0.28571429rem 0 0;
}

h1:first-child,
h2:first-child,
h3:first-child,
h4:first-child,
h5:first-child {
  margin-top: 0;
}

h3 {
  font-size: 0.729vw;
}

h1,
h2,
h3,
h4,
h5 {
  line-height: 1.28571429em;
  margin: calc(2rem - 0.14285714em) 0 1rem;
  padding: 0;
}

.ui.category.search > .results .category .results {
  display: table-cell;
  background: #fff;
}

.ui.icon.input > i.icon:after,
.ui.icon.input > i.icon:before {
  left: -1185px;
  text-align: center;
  top: 40%;
  width: 100%;
  margin-top: -0.5em;
  background-color: grey;
}

i.icon.search:before {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-color: black;
  color: bisque;
  height: 50%;
  width: 50%;
}

i.icon:before {
  background: 0 0 !important;
}

.category_name {
  font-size: var(--label-FontSize);
  font-family: var(--label-FontName);
  font-weight: var(--label-FontWeight);
  color: var(--label-FontColour);
  background: white;
  padding: 10px 0px 10px 20px;
  line-height: 16px;
  display: flex;
}

.result {
  font-size: var(--default-FontSize);
  font-family: var(--default-FontName);
  font-weight: var(--default-FontWeight);
  color: var(--default-FontColour);
  padding: 0px 0px 0px 20px;
  line-height: 20px;
  cursor: pointer;
}

.mainDiv {
  overflow: scroll;
  background: white;
}

.subDiv {
  height: auto;
  background: 'white';
}

.SearchBarIcon {
  margin-left: 55.1%;
  position: absolute;
  margin-top: -0.85rem;
  cursor: pointer;
}

.viewMore {
  padding: 0px 15px;
  cursor: pointer;
  text-decoration: underline;
}

.childern__hidden .results.transition {
  opacity: 0;
}

.childern__visible .results.transition {
  opacity: 1;
}

::placeholder {
  color: var(--controltext-colour);
}

.ui.input {
  height: inherit;
  width: 100%;
}

.searchIcon {
  height: 40px;
}

.ui.input > input::placeholder {
  color: #b7b7b7;
  font-size: var(--default-FontSize);
  font-family: var(--default-FontName);
  font-style: normal;
  font-weight: var(--default-FontWeight);
  line-height: 21px;
}

img.searchiconimage {
  width: inherit;
  cursor: pointer;
  background-color: #1f3c88;

  position: absolute;
  line-height: 1;
  text-align: center;
  top: 0;
  right: 0;
  margin: 0;
  height: 100%;

  width: 50px;
  transition: opacity 0.3s ease;
  border-top-right-radius: 50px;
  border-bottom-right-radius: 50px;
  display: inline-block;
  font-family: Icons;
  font-style: normal;
  font-weight: 400;
  text-decoration: inherit;
  speak: none;
  -webkit-font-smoothing: antialiased;
  backface-visibility: hidden;

  padding: 1.5%;
  cursor: pointer;
}

.searchiconmaindiv {
  width: 13%;
  margin-left: -74px;

  display: flex;
  justify-content: flex-start;
  align-items: center;
  color: var(--default-FontColour);
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/views/components/custom/searchBar/SearchBar.css"],"names":[],"mappings":"AAAA;;;CAGC;AACD;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,6BAA6B;EAC7B,mBAAmB;EACnB,eAAe;EACf,0BAA0B;EAC1B,oBAAoB;EACpB,UAAU;AACZ;;AAEA;;;;EAIE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;;EAEE,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,2BAA2B;EAC3B,oBAAoB;EACpB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,UAAU;EACV,gBAAgB;EAChB,qBAAqB;EACrB,kCAAkC;EAClC,oCAAoC;EACpC,sCAAsC;EACtC,gCAAgC;EAChC,yBAAyB;EACzB,+BAA+B;EAC/B,wDAAwD;EACxD,6CAA6C;EAC7C,sDAAsD;EACtD,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,aAAa;EACb,6BAA6B;EAC7B,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,WAAW;EACX,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,4BAA4B;EAC5B,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,4BAA4B;EAC5B,6EAA6E;EAC7E,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,4BAA4B;EAC5B,wBAAwB;EACxB,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;;;EAGE,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,kCAAkC;EAClC,oCAAoC;EACpC,8BAA8B;AAChC;;AAEA,QAAQ;AACR;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,4BAA4B;EAC5B,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,4BAA4B;EAC5B,6EAA6E;EAC7E,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,wBAAwB;EACxB,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,wDAAwD;AAC1D;;AAEA;EACE,8CAA8C;AAChD;;AAEA;;;;;EAKE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;;;EAKE,yBAAyB;EACzB,wCAAwC;EACxC,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,gDAAyD;EACzD,uBAAuB;EACvB,aAAa;EACb,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;EAChC,kCAAkC;EAClC,oCAAoC;EACpC,8BAA8B;EAC9B,iBAAiB;EACjB,2BAA2B;EAC3B,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,sCAAsC;EACtC,gCAAgC;EAChC,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kCAAkC;EAClC,oCAAoC;EACpC,kBAAkB;EAClB,sCAAsC;EACtC,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,yBAAyB;;EAEzB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,YAAY;;EAEZ,WAAW;EACX,6BAA6B;EAC7B,6BAA6B;EAC7B,gCAAgC;EAChC,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,WAAW;EACX,mCAAmC;EACnC,2BAA2B;;EAE3B,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,kBAAkB;;EAElB,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,gCAAgC;EAChC,eAAe;AACjB","sourcesContent":["/*\nThis computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), \nis the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.\n*/\n.ui.grid {\n  margin: -1rem auto -1rem auto;\n}\n\n.ui.grid {\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n  flex-direction: row;\n  flex-wrap: wrap;\n  -webkit-box-align: stretch;\n  align-items: stretch;\n  padding: 0;\n}\n\n.ui.column.grid > [class*='eight wide'].column,\n.ui.grid > .column.row > [class*='eight wide'].column,\n.ui.grid > .row > [class*='eight wide'].column,\n.ui.grid > [class*='eight wide'].column {\n  width: 50% !important;\n}\n\n.ui.grid > .column:not(.row) {\n  padding-top: 1rem;\n  padding-bottom: 1rem;\n}\n\n.ui.grid > .column:not(.row),\n.ui.grid > .row > .column {\n  position: relative;\n  display: inline-block;\n  width: 6.25%;\n  padding-right: 0rem;\n  vertical-align: top;\n}\n\n.ui.search {\n  height: inherit;\n}\n\n.ui.input {\n  position: relative;\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  height: 1.88rem;\n  border-radius: 14px;\n}\n\n.ui.input > input {\n  margin: 0;\n  max-width: 100%;\n  -webkit-box-flex: 1;\n  flex: 1 0 auto;\n  outline: 0;\n  text-align: left;\n  line-height: 1.313rem;\n  font-size: var(--default-FontSize);\n  font-family: var(--default-FontName);\n  font-weight: var(--default-FontWeight);\n  color: var(--default-FontColour);\n  padding: 0.67857143em 1em;\n  /* background-color: #ececec; */\n  /* border: 0.006rem solid var(--controlborder-colour); */\n  background-color: var(--inputbackgroundColor);\n  border: 1px solid var(--searchBarControlBorder-colour);\n  box-shadow: none;\n  border-radius: 50px;\n  font-style: normal;\n  padding-left: 20px;\n  padding-right: 74px;\n}\n\nbutton,\ninput {\n  overflow: visible;\n}\n\n*,\n:after,\n:before {\n  box-sizing: inherit;\n}\n\n.ui.icon.input > i.icon:not(.link) {\n  pointer-events: none;\n}\n\n.ui.search .prompt ~ .search.icon {\n  cursor: pointer;\n  background-color: #1f3c88;\n  content-visibility: hidden;\n}\n\n.ui.icon.input > i.icon {\n  position: absolute;\n  line-height: 1;\n  text-align: center;\n  top: 0;\n  right: 0;\n  margin: 0;\n  height: 100%;\n  width: 6.325%;\n  transition: opacity 0.3s ease;\n  border-top-right-radius: 50px;\n  border-bottom-right-radius: 50px;\n}\n\ni.icon,\ni.icons {\n  font-size: 0.833vw;\n}\n\ni.icon {\n  display: inline-block;\n  font-family: Icons;\n  font-style: normal;\n  font-weight: 400;\n  text-decoration: inherit;\n  speak: none;\n  -webkit-font-smoothing: antialiased;\n  backface-visibility: hidden;\n}\n\n*,\n:after,\n:before {\n  box-sizing: inherit;\n}\n\n.ui.category.search .results {\n  width: 28em;\n}\n\n.ui.search > .results {\n  display: none;\n  position: absolute;\n  top: 100%;\n  left: 0;\n  transform-origin: center top;\n  white-space: normal;\n  text-align: left;\n  text-transform: none;\n  background: #fff;\n  margin-top: 0.5em;\n  border-radius: 0.28571429rem;\n  box-shadow: 0 2px 4px 0 rgb(34 36 38 / 12%), 0 2px 10px 0 rgb(34 36 38 / 15%);\n  border: 1px solid #d4d4d5;\n  z-index: 998;\n}\n\n.transition {\n  animation-iteration-count: 1;\n  animation-duration: 0.3s;\n  animation-timing-function: ease;\n  animation-fill-mode: both;\n}\n\n*,\n:after,\n:before {\n  -webkit-box-sizing: inherit;\n  box-sizing: inherit;\n}\n\n.ui.search > .results > .message {\n  padding: 1em 1em;\n}\n\n.ui.search > .results > :last-child {\n  border-radius: 0 0 0.28571429rem 0.28571429rem;\n}\n\n*,\n:after,\n:before {\n  box-sizing: inherit;\n}\n\n.ui.search > .results > .message .header {\n  font-size: var(--label-FontSize);\n  font-family: var(--label-FontName);\n  font-weight: var(--label-FontWeight);\n  color: var(--label-FontColour);\n}\n\n/*Popup*/\n.ui.category.search .results.animating,\n.ui.category.search .results.visible {\n  display: none !important;\n}\n\n.ui.category.search .results {\n  width: 28em;\n}\n\n.ui.search > .results {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  transform-origin: center top;\n  white-space: normal;\n  text-align: left;\n  text-transform: none;\n  background: #fff;\n  margin-top: 0.5em;\n  border-radius: 0.28571429rem;\n  box-shadow: 0 2px 4px 0 rgb(34 36 38 / 12%), 0 2px 10px 0 rgb(34 36 38 / 15%);\n  border: 1px solid #d4d4d5;\n  z-index: 998;\n}\n\n.visible.transition {\n  display: block !important;\n  visibility: visible !important;\n  max-height: 70vh;\n  overflow: scroll;\n}\n\n.transition {\n  animation-iteration-count: 1;\n  animation-duration: 0.3s;\n  animation-timing-function: ease;\n  animation-fill-mode: both;\n}\n\n.ui.category.search > .results .category {\n  display: table-row;\n  background: #f3f4f5;\n  box-shadow: none;\n  transition: background 0.1s ease, border-color 0.1s ease;\n}\n\n.ui.search > .results > :first-child {\n  border-radius: 0.28571429rem 0.28571429rem 0 0;\n}\n\nh1:first-child,\nh2:first-child,\nh3:first-child,\nh4:first-child,\nh5:first-child {\n  margin-top: 0;\n}\n\nh3 {\n  font-size: 0.729vw;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5 {\n  line-height: 1.28571429em;\n  margin: calc(2rem - 0.14285714em) 0 1rem;\n  padding: 0;\n}\n\n.ui.category.search > .results .category .results {\n  display: table-cell;\n  background: #fff;\n}\n\n.ui.icon.input > i.icon:after,\n.ui.icon.input > i.icon:before {\n  left: -1185px;\n  text-align: center;\n  top: 40%;\n  width: 100%;\n  margin-top: -0.5em;\n  background-color: grey;\n}\n\ni.icon.search:before {\n  content: url(../../../../assets/images/search_icon24.png);\n  background-color: black;\n  color: bisque;\n  height: 50%;\n  width: 50%;\n}\n\ni.icon:before {\n  background: 0 0 !important;\n}\n\n.category_name {\n  font-size: var(--label-FontSize);\n  font-family: var(--label-FontName);\n  font-weight: var(--label-FontWeight);\n  color: var(--label-FontColour);\n  background: white;\n  padding: 10px 0px 10px 20px;\n  line-height: 16px;\n  display: flex;\n}\n\n.result {\n  font-size: var(--default-FontSize);\n  font-family: var(--default-FontName);\n  font-weight: var(--default-FontWeight);\n  color: var(--default-FontColour);\n  padding: 0px 0px 0px 20px;\n  line-height: 20px;\n  cursor: pointer;\n}\n\n.mainDiv {\n  overflow: scroll;\n  background: white;\n}\n\n.subDiv {\n  height: auto;\n  background: 'white';\n}\n\n.SearchBarIcon {\n  margin-left: 55.1%;\n  position: absolute;\n  margin-top: -0.85rem;\n  cursor: pointer;\n}\n\n.viewMore {\n  padding: 0px 15px;\n  cursor: pointer;\n  text-decoration: underline;\n}\n\n.childern__hidden .results.transition {\n  opacity: 0;\n}\n\n.childern__visible .results.transition {\n  opacity: 1;\n}\n\n::placeholder {\n  color: var(--controltext-colour);\n}\n\n.ui.input {\n  height: inherit;\n  width: 100%;\n}\n\n.searchIcon {\n  height: 40px;\n}\n\n.ui.input > input::placeholder {\n  color: #b7b7b7;\n  font-size: var(--default-FontSize);\n  font-family: var(--default-FontName);\n  font-style: normal;\n  font-weight: var(--default-FontWeight);\n  line-height: 21px;\n}\n\nimg.searchiconimage {\n  width: inherit;\n  cursor: pointer;\n  background-color: #1f3c88;\n\n  position: absolute;\n  line-height: 1;\n  text-align: center;\n  top: 0;\n  right: 0;\n  margin: 0;\n  height: 100%;\n\n  width: 50px;\n  transition: opacity 0.3s ease;\n  border-top-right-radius: 50px;\n  border-bottom-right-radius: 50px;\n  display: inline-block;\n  font-family: Icons;\n  font-style: normal;\n  font-weight: 400;\n  text-decoration: inherit;\n  speak: none;\n  -webkit-font-smoothing: antialiased;\n  backface-visibility: hidden;\n\n  padding: 1.5%;\n  cursor: pointer;\n}\n\n.searchiconmaindiv {\n  width: 13%;\n  margin-left: -74px;\n\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  color: var(--default-FontColour);\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
